/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { YMInitializer } from 'react-yandex-metrika';
import { BrowserRouter } from 'react-router-dom';
import MainBlock from '../../components/MainBlock';
import { Wrapper } from './styled/Main.styled';

const Main = () => (
    <BrowserRouter>
        <Wrapper>
            <MainBlock />
            <YMInitializer
                accounts={[14469772]}
                options={{
                    id: 14469772,
                    webvisor: true,
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true
                }}
                version="2"
            />
        </Wrapper>
    </BrowserRouter>
);

export default Main;
